import { actions } from "@grandvisionhq/state";
import { getFileUploadResult } from "../../../../utils/utils/get-file-upload-result.js";
const fileUploadResult = actions.action(
  "products/prescription-glasses/file-upload-result",
  (result) => ({
    result: getFileUploadResult(result)
  })
);
export {
  fileUploadResult
};
//# sourceMappingURL=actions.js.map
